// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__29iXh","range":"MonthRangeSwitch_range__1Wx3B","disabled":"MonthRangeSwitch_disabled__2wAaJ"};